export default __webpack_public_path__ + "static/master_matchmaker-e2107350d30d8b98133c369c842f8b91.svg";